/*global UploaderForm, Backbone, _, $ */
'use strict';

var Backbone        = require('backbone');
var $               = require('jquery');
var _               = require('lodash');

var template        = require('./../tmp/templates');

module.exports = Backbone.View.extend({
    tagName: 'style',
    className: 'view-css',

    initialize: function(options) {
        this.template = options.template ? template[options.template] : template['css'];
        this.namespace = options.namespace || '';

        this.model.namespace = this.namespace;

        this.$el.prop('type', 'text/css');
    },

    /**
     *
     */
    render: function() {
        this.$el.append(this.template(this.model));

        return this;
    }
});
